import React from "react";
import { ExternalLink, Package } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  shipmentId: string;
  shipmentNumber?: string;
}

export const ShipmentBadge: React.FC<Props> = ({ shipmentId, shipmentNumber }) => {
  const { t } = useTranslation("tasks");
  const navigate = useNavigate();
  const label = shipmentNumber ?? shipmentId;

  return (
    <button
      type="button"
      onClick={() => navigate(`/shipments/${shipmentId}`)}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 transition-colors"
      title={t("shipment.goToShipment")}
    >
      <Package className="w-3.5 h-3.5" />
      <span>{t("shipment.createdBadge", { id: label })}</span>
      <ExternalLink className="w-3 h-3" />
    </button>
  );
};
